import React from 'react';

import { CommonHoursConfirmProps } from 'types';
import Button from 'components/Button/Button';

import ErrorInfoIcon from 'icons/ic_ErrorInfo.svg';

interface ComponentProps {
  styles: {
    [key: string]: string;
  };
  closeModal: () => void;
}

/**
 * CommonHoursConfirm Modal
 *
 * This modal is displayed when a user attempts to publish a menu for a newly subscribed app
 * when hours are automatically applied from the primary menu of other apps(common menu hours logic)
 * without first reviewing and updating menu hours
 *
 * This prevents menu publish until hours are manually updated and saved for the new app's menu
 *
 */
const CommonHoursConfirm: React.FC<CommonHoursConfirmProps & ComponentProps> = ({ callback, styles, closeModal }) => {
  return (
    <div data-testid="menu-cannot-be-published" role="dialog" aria-labelledby="menu-cannot-be-published-title">
      <img src={ErrorInfoIcon} alt="info" />
      <h2 id="title" className={styles.NoMargin} style={{ marginBottom: '30px' }}>
        Menu can&rsquo;t be published.
      </h2>
      <p id="menu-cannot-be-published-body" data-testid="menu-cannot-be-published-body">
        You need to review and set the menu hours for this app before the menu can be published.
      </p>
      <div className={styles.ButtonRow}>
        <Button onClick={closeModal} level="low">
          <span>Cancel</span>
        </Button>
        <Button
          onClick={() => {
            callback();
            closeModal();
          }}
        >
          Review menu hours
        </Button>
      </div>
    </div>
  );
};

export default CommonHoursConfirm;
